import { useState } from "react";
import { api } from "../../../../../../../../utility/api";
import { descargarReporteExcel } from "../../../../helpers/descargarReporteExcel";

export const ComparativoMensualProduccionApi = () => {
    const [cargando, setCargando] = useState(false);

    const getComparativoMensual = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(
                "reportes_produccion/comparativo_mensual",
                params,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const descargarComparativoMensualExcel = async (params) => {
        try {
            setCargando(true);
            await descargarReporteExcel(
                "reportes_produccion/comparativo_mensual_excel",
                params,
                "cierre_mensual_produccion.xlsx",
            );
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getComparativoMensual,
        descargarComparativoMensualExcel,

        cargando,
    };
};
